<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-users"></i>
            </span>
            <h3 class="kt-portlet__head-title">จัดการข้อมูลสมาชิกตัวแทน/ตัวแทนจำหน่ายย่อย</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="keyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อผู้ใช้งาน ชื่อบัญชี อีเมล เบอร์โทรศัพท์"
                  />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label>โปรไฟล์บริษัท:</label>
                  <select
                    ref="companyProfileId"
                    class="form-control m-select2"
                    style="width: 100%;"
                  ></select>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button type="reset" class="btn btn-secondary" @click="formReset">ล้างค่าทั้งหมด</button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="AgentUsers/Add"
                  tag="button"
                  title="เพิ่มข้อมูลสมาชิก"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShowExSuperAdmin('MANAGE_SUB_AGENT_USER')"
                >
                  <i class="fa fa-user-plus"></i> เพิ่มข้อมูลสมาชิก
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="userTable"
              >
                <thead>
                  <tr>
                    <th>ชื่อผู้ใช้งาน (Username)</th>
                    <th>อีเมล</th>
                    <th>ชื่อ - ชื่อสกุล</th>
                    <th>โทรศัพท์</th>
                    <th>ตำแหน่ง</th>
                    <th>โปรไฟล์บริษัท</th>
                    <th>วันที่เข้าใช้งานล่าสุด</th>
                    <th>คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>

    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let UserActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูลสมาชิก">
      <i class="la la-edit"></i>
    </a>
    <a href="#"@click.prevent="forgotPassword" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ส่งอีเมลรีเซ็ตรหัสผ่าน">
      <i class="la la-envelope"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({ path: `/Master/AgentUsers/Edit/${this.data.userName}` });
    },
    forgotPassword: function() {
      Swal.fire({
        title: "ส่งอีเมลรีเซ็ตรหัสผ่าน",
        html:
          "ระบบจะส่งลิ้งค์สำหรับรีเซ็ตรหัสผ่านของ <strong>" +
          this.data.userName +
          "</strong> ไปยังอีเมล <strong>" +
          this.data.email +
          "</strong>",
        showCancelButton: true,
        confirmButtonText: "ส่งอีเมล",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังส่งอีเมล กรุณารอสักครู่..."
          });

          axios
            .post("/Api/Users/ForgotPassword", {
              userName: this.data.userName,
              email: result.value
            })
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});

export default {
  data: function() {
    return {
      keyword: "",
      companyProfileId: null
    };
  },
  methods: {
    formReset: function(e) {
      this.keyword = "";
      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#userTable").DataTable();
      table.search(this.keyword);
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#userTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    }
  },
  async mounted() {
    let self = this;
    const user = await this.$root.getUser();
    var table = $("#userTable");

    $(self.$refs.companyProfileId)
      .select2({
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      })
      .on("change", function() {
        self.companyProfileId = $(this).val();
      });
    $.fn.dataTable.ext.errMode = 'none';
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,

        ajax: {
          url: "/Api/Users/Find",
          type: "post",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return $.extend({}, d, {
              companyProfileId: self.companyProfileId
            });
          }
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
      <'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_"
        },

        // Order settings
        order: [[6, "desc"]],

        columns: [
          { data: "userName" },
          { data: "email" },
          { data: "fullName" },
          { data: "phoneNumber", className: "text-center" },
          { data: "position", className: "text-center" },
          { data: "companyProfiles", width: "15%" },
          {
            data: "lastLogOnDateTime",
            className: "text-center",
            render: function(data, type, row, meta) {
              return row.lastLogOnDateTimeString;
            }
          },
          {
            data: "userName",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            }
          }
        ]
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShowExSuperAdmin("MANAGE_SUB_AGENT_USER");
            new UserActions({ data: { data } }).$mount(el);
          }
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      });
  }
};
</script>


// WEBPACK FOOTER //
// App/Components/Master/User/AgentUserList.vue